export function walkInOptionMapper(params) {
  let payload = {};
  if (params.config.featuresFlags.walkInSelfEvaluation) {
    payload = {
      options: {
        walkIn: params.config.featuresFlags.walkInSelfEvaluation
      }
    };
  }
  return payload;
}